import { Text } from '@cabonline/ui-web';
import { useLocale } from '@multiplatform-apps/service-trips';
import { FC } from 'react';

import { useDeviceType } from '../../../hooks';
import { LanguageSelect } from '../../language-select';
import { StyledHead } from './styles';

export const MenuHeader: FC = () => {
  const { t } = useLocale();
  const deviceType = useDeviceType();

  return (
    <StyledHead>
      <Text as="h1" size="xl" weight="extraBold">
        {t('mobileMenu.title')}
      </Text>
      <LanguageSelect
        darkMode={deviceType === 'desktop'}
        id="mobile-language-select"
      />
    </StyledHead>
  );
};
